import { Component, Inject, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Prompt modal.
 *
 * Has one input field, which can either set or edit a value.
 * On save, the (new) value is returned.
 */
@Component({
  selector: 'sg2-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.less']
})
export class ModalPromptComponent implements AfterViewInit {

  @ViewChild('valueInput') inputEl: ElementRef;

  /** Constructor. */
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly config: any,
    private dialogRef: MatDialogRef<ModalPromptComponent>
  ) { }


  ngAfterViewInit() {
    // Select and focus the prompt input
    setTimeout(() => {this.inputEl.nativeElement.select(); }, 0);
  }
  /**
   * Close the modal.
   *
   * @returns Null (explicitly no value/action)
   */
  cancel(): null | any {
    this.dialogRef.close(null);
  }

  /**
   * Submit value.
   *
   * @returns Entered or edited value. Always a string, even when empty.
   */
  submit(): string | any {
    this.dialogRef.close(this.config.value);
  }

}
